export default __webpack_public_path__ + "static/media/brand15.71ef10e6.svg";